export const isMan = (pesel: string) => +pesel[9] % 2;
